// Activation tracking reads edits from workflow history, so every save made by an AI action is
// flagged there, and the text it writes on cards carries the flag too: a person editing AI text
// in a later session is still recognised.

// Whether a save happening right now is the AI's. Counted, not a flag: AI actions can overlap.
let openAiWrites = 0

export const isAiGenerationRunning = () => openAiWrites > 0

// Every save inside `action` is the AI's. An action that also waits on the model, while the
// person can still edit by hand, wraps only the part that applies the AI's changes.
export const runAiWrites = async (action) => {
  openAiWrites++

  try {
    return await action()
  } finally {
    openAiWrites--
  }
}

export const markAiUpdateNote = (input) => {
  if (isAiGenerationRunning() && input) {
    input.updateNote = { ...input.updateNote, aiGenerated: true }
  }
}

export const cardIdsOf = (workflow) => new Set((workflow?.domainEvents || [])
  .flatMap((event) => event.cards || [])
  .map((card) => card.id))

export const cardsByIdOf = (workflow) => new Map((workflow?.domainEvents || [])
  .flatMap((event) => event.cards || [])
  .map((card) => [card.id, card]))

// Only cards whose text the AI wrote: an update always resends the description, so a card the AI
// merely ticked done or moved keeps whoever wrote it. existingById: the cards as they are now.
export const markAiCards = (cards, existingById = new Map()) => {
  if (isAiGenerationRunning()) {
    (cards || []).forEach((card) => {
      const existing = existingById.get(card.cardId ?? card.id)

      if (!existing || existing.description !== card.description) {
        card.aiGenerated = true
      }
    })
  }
}

export const markNewAiCards = (domainEvents, existingCardIds) => {
  if (isAiGenerationRunning()) {
    markAiCards((domainEvents || []).flatMap((event) => event.cards || []).filter((card) => !existingCardIds.has(card.id)))
  }
}

// updateCards does not return the flag (an update would null it out), so new AI cards get it from their input.
export const copyAiFlags = (inputCards, resultCards) => {
  (inputCards || []).forEach((card, index) => {
    if (card.aiGenerated && resultCards?.[index]) {
      resultCards[index].aiGenerated = true
    }
  })
}
